import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

const AuthSection = ({ data }) => {
  const [copied, setCopied] = useState(false);

  if (!data) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(data.headerExample);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div id="api-key-usage">
      <h1>{data.title}</h1>
      <p className="apidocs-lead">{data.description}</p>

      <span className="apidocs-label">Header format</span>
      <div className="apidocs-pre-wrap">
        <code>{data.headerExample}</code>
        <button type="button" onClick={handleCopy}>
          {copied ? <Check size={13} /> : <Copy size={13} />}
        </button>
      </div>

      <ul className="apidocs-bullets">
        {data.notes.map((note, i) => (
          <li key={i}>{note}</li>
        ))}
      </ul>

      <div className="apidocs-note warn">
        <b>Security</b>
        <p>
          Never expose your API key in client-side code, public repositories, or browser requests.
          Always make API calls from your backend. If a key is compromised, revoke it on the API Keys page.
        </p>
      </div>
    </div>
  );
};

export default AuthSection;
